export default __webpack_public_path__ + "static/media/public-room.c7d70be2.png";